<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="filteredStates"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <color-picker
                v-if="!state"
                :value="color"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'hover'"
                :value="hoverColor"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'selected'"
                :value="selectedColor"
                @input="onInput"
            />

            <color-picker
                v-if="state === 'matching'"
                :value="matchingColor"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import colorData from '@/data/constants/colors';

export default {
    name: 'color',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Text Color',
            color: '',
            hoverColor: '',
            selectedColor: '',
            matchingColor: '',

            state: '',
            states: [
                {
                    text: 'Default',
                    value: '',
                },
                {
                    text: 'Hover',
                    value: 'hover',
                },
                {
                    text: 'Selected',
                    value: 'selected',
                    displayFor: ['a-text-single-line', 'links-nav', 'nav-dropdown'],
                },
                {
                    text: 'Matching',
                    value: 'matching',
                    displayFor: ['a-link', 'nav-dropdown'],
                },
            ],

            tailwindDefinitionProp: 'textColor',
        };
    },

    computed: {
        filteredStates() {
            const { elementType } = this.selectedElements[0];

            return this.states.filter((state) => {
                if (state.displayFor) {
                    return state.displayFor.includes(elementType);
                }

                return true;
            });
        },
    },

    methods: {
        onInput(color) {
            const localColorProp = this.state ? `${ this.state }Color` : 'color';

            if (color === colorData.NO_COLOR_FLAG) {
                this[localColorProp] = '';
                this.removeFlexClass(this.state);
                this.onOptionChange();
                return;
            }

            const flexClassNew = this.addFlexClass({
                value: color,
                state: this.state,
            });

            this[localColorProp] = color;
            this.onOptionChange(flexClassNew);
        },

        onStateInput(newState) {
            this.state = newState;
            this.setDefaultColor();
        },

        onSelectedElement() {
            this.state = this.flexClassDefinition.state || '';
            this.setDefaultColor();
        },
    },
};
</script>
